export default __webpack_public_path__ + "static/media/courier-pin.e00adc4a.svg";